import { atom } from 'jotai';
import { pendingQueue } from 'shared/utils/pending-queue';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';
import { ImmersiveArticleData } from './article-immersive-related-post';

export interface IArticleRelatedPostWithImmersiveData {
  searchId: string;
  items: ImmersiveArticleData[];
  cursor: number;
  hasMore: boolean;
}

type TArticleRelatedPostWithImmersiveDataStore = {
  [key: string]: Promise<IArticleRelatedPostWithImmersiveData> | IArticleRelatedPostWithImmersiveData | undefined;
};

const $ArticleRelatedPostWithImmersiveDataStore = atom<TArticleRelatedPostWithImmersiveDataStore>({});

export const $ArticleRelatedPostWithImmersiveData = safeAtomFamily((groupId: string) => {
  const a = atom(
    (get) => {
      const data = get($ArticleRelatedPostWithImmersiveDataStore)[groupId];
      if (!data) {
        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        throw new Promise((resolve) => pendingQueue.push(resolve));
      }
      return data;
    },
    (get, set, input: IArticleRelatedPostWithImmersiveData | Promise<IArticleRelatedPostWithImmersiveData>) => {
      const old = get($ArticleRelatedPostWithImmersiveDataStore);
      set($ArticleRelatedPostWithImmersiveDataStore, {
        ...old,
        [groupId]: input,
      });
    },
  );

  a.debugLabel = `$ArticleRelatedPostWithImmersiveData+${encodeURIComponent(groupId)}`;

  return a;
});
